import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PaymentState, Payment } from '@/types'

const initialState: PaymentState = {
  payments: [],
  currentPayment: null,
  isLoading: false,
  error: null,
}

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    setCurrentPayment: (state, action: PayloadAction<Payment | null>) => {
      state.currentPayment = action.payload
    },
    updatePaymentStatus: (state, action: PayloadAction<{ id: string | number; status: string }>) => {
      const payment = state.payments.find(p => p.id === action.payload.id)
      if (payment) {
        payment.status = action.payload.status as any
      }
      if (state.currentPayment?.id === action.payload.id) {
        state.currentPayment.status = action.payload.status as any
      }
    },
    setPayments: (state, action: PayloadAction<Payment[]>) => {
      state.payments = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
    },
  },
})

export const {
  clearError,
  setCurrentPayment,
  updatePaymentStatus,
  setPayments,
  setLoading,
  setError,
} = paymentSlice.actions

export default paymentSlice.reducer